import { api } from './base';

export type ComponentStatus = 'up' | 'degraded' | 'down';
export type ComponentStatusOrUnknown = ComponentStatus | 'unknown';

export interface ComponentSummary {
  key: string;
  label: string;
  status: ComponentStatusOrUnknown;
  detail: string | null;
  since: string | null;
}

export interface StatusSummary {
  overall: ComponentStatusOrUnknown;
  checkedAt: string | null;
  components: ComponentSummary[];
}

export interface DayIncident {
  status: 'down' | 'degraded';
  from: string;
  to: string;
  startedEarlier: boolean;
  ongoing: boolean;
  detail: string | null;
  eventId: string | null;
}

export interface StatusDay {
  date: string;
  downMinutes: number;
  degradedMinutes: number;
  unknownMinutes: number;
  incidents: DayIncident[];
}

export interface IncidentEntry {
  id: string;
  component: string;
  label: string;
  status: 'down' | 'degraded';
  detail: string | null;
  startedAt: string;
  endedAt: string | null;
}

export interface IncidentPage {
  items: IncidentEntry[];
  nextBefore: string | null;
}

export interface ComponentHistory {
  key: string;
  label: string;
  uptime: number | null;
  days: StatusDay[];
}

export interface StatusHistory {
  days: number;
  components: ComponentHistory[];
}

export const systemStatusApi = {
  summary: () => api.get<StatusSummary>('/api/v1/status', undefined, { toast: false }),
  history: () => api.get<StatusHistory>('/api/v1/status/history', undefined, { toast: false }),
  incidents: (before?: string | null) =>
    api.get<IncidentPage>('/api/v1/status/incidents', before ? { before } : undefined, { toast: false }),
  incidentsUntil: (eventId: string) =>
    api.get<IncidentPage>('/api/v1/status/incidents', { until: eventId }, { toast: false }),
};
